module.exports = __webpack_public_path__ + "static/media/hw_to_20.304fbc64.flv";